const namespace = "COUNTRY_CODES";

export const REQUEST_COUNTRY_CODES = `${namespace}/REQUEST_COUNTRY_CODES`;
export const RECEIVE_COUNTRY_CODES_SUCCESS = `${namespace}/RECEIVE_COUNTRY_CODES_SUCCESS`;
export const RECEIVE_COUNTRY_CODES_FAILURE = `${namespace}/RECEIVE_COUNTRY_CODES_FAILURE`;
